import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-widget-commodite-ville',
    templateUrl: './commodite-ville.component.html',
    styleUrls: ['./commodite-ville.component.scss']
})
export class CommoditeVilleComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville', 'france'];

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            this.displayedColumns = ['lib', 'quartier', 'ville', 'france'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
    }

    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.carac_commune_iris[this.iris]) {
            irisData = this.favorite.ad_city.carac_commune_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.carac_commune_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.carac_commune_gq[this.secteur];
        }

        let irisDataLogement = null;
        if (this.iris != '' && this.favorite.ad_city.logement_iris[this.iris]) {
            irisDataLogement = this.favorite.ad_city.logement_iris[this.iris];
        }

        let secteurDataLogement = null;
        if (this.secteur != '' && this.favorite.ad_city.logement_gq[this.secteur]) {
            secteurDataLogement = this.favorite.ad_city.logement_gq[this.secteur];
        }

        this.compare = [
            {
                'lib': 'Niveau de vie moyen par habitant',
                'quartier': (irisData != null ?  new Intl.NumberFormat('fr-FR').format(irisData.MED_NV) + " €" : '-'),
                'secteur': (secteurData != null ?  new Intl.NumberFormat('fr-FR').format(secteurData.MED_NV) + " €" : '-'),
                'ville':  new Intl.NumberFormat('fr-FR').format(this.favorite.ad_city.carac_commune.MED_NV) + " €",
                'france':  new Intl.NumberFormat('fr-FR').format(this.favorite.ad_city.carac_commune_fr.MED_NV) + " €",
            },
            {
                'lib': 'Taux de logements vacants',
                'quartier': (irisDataLogement != null ?  (irisDataLogement.T_LV * 100).toFixed(1) + " %" : '-'),
                'secteur': (secteurDataLogement != null ? (secteurDataLogement.T_LV * 100).toFixed(1) + " %" : '-'),
                'ville': (this.favorite.ad_city.logement.T_LV * 100).toFixed(1) + " %",
                'france': (this.favorite.ad_city.logement_fr.T_LV * 100).toFixed(1) + " %",
            },
            {
                'lib': 'Taux de taxe foncière',
                'quartier': '-',
                'secteur': '-',
                'ville':  (this.favorite.ad_city.logement.TF * 100).toFixed(1) + " %",
                'france':  (this.favorite.ad_city.logement_fr.TF * 100).toFixed(1) + " %",
            },
            {
                'lib': 'Ancienneté des locataires dans le logement',
                'quartier': (irisDataLogement != null ? ((irisDataLogement.anc_loc_ann * 10) / 10).toFixed(1) + " ans" : '-'),
                'secteur': (secteurDataLogement != null ? ((secteurDataLogement.anc_loc_ann * 10) / 10).toFixed(1) + " ans" : '-'),
                'ville': ((this.favorite.ad_city.logement.anc_loc_ann * 10) / 10).toFixed(1) + " ans",
                'france': ((this.favorite.ad_city.logement_fr.anc_loc_ann * 10) / 10).toFixed(1) + " ans",
            },
            {
                'lib': 'Part des ménages ayant au moins 1 voiture',
                'quartier': (irisDataLogement != null ?  (irisDataLogement['T_Men_1+voit'] * 100).toFixed(1) + " %" : '-'),
                'secteur': (secteurDataLogement != null ?  (secteurDataLogement['T_Men_1+voit'] * 100).toFixed(1) + " %" : '-'),
                'ville': (this.favorite.ad_city.logement['T_Men_1+voit'] * 100).toFixed(1) + " %",
                'france': (this.favorite.ad_city.logement_fr['T_Men_1+voit'] * 100).toFixed(1) + " %",
            },
            {
                'lib': 'Part des ménages ayant une place de parking',
                'quartier': (irisDataLogement != null ? (irisDataLogement.T_Men_park * 100).toFixed(1) + " %" : '-'),
                'secteur': (secteurDataLogement != null ? (secteurDataLogement.T_Men_park * 100).toFixed(1) + " %" : '-'),
                'ville': (this.favorite.ad_city.logement.T_Men_park * 100).toFixed(1) + " %",
                'france': (this.favorite.ad_city.logement_fr.T_Men_park * 100).toFixed(1) + " %",
            },
        ]
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

}
